export default {
  // [通用数据] - 开通城市查询
  cities: '/courier/api/v2/cities',
  city: '/v3/regist/get/city'
}
